import { render, staticRenderFns } from "./CoaTemplate.vue?vue&type=template&id=2194bf5e&"
import script from "./CoaTemplate.vue?vue&type=script&lang=js&"
export * from "./CoaTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports